<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Usuario</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <user-form :server-errors="serverErrors" @save="saveUser"></user-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import UserForm from '@/views/Users/Forms/UserForm';
import swal from 'sweetalert2';

export default {
  name: 'UsersCreate',
  components: {
    RouteBreadCrumb,
    UserForm,
  },

  data() {
    return {
      serverErrors: [],
    };
  },

  methods: {
    saveUser(user) {
      this.serverErrors = [];
      this.$services
        .resource('users')
        .create(user)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El usuario fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'UsersList' }));
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },
  },
};
</script>
